import { Permission } from '../enum/permission.enum';

export const PERMISSIONS_BY_TID: Record<
  string,
  { visible: Permission[]; hidden: Permission[] }
> = Object.entries({
  // Transitalia -> Acceso completo
  '3c9528a9-1142-4f50-b66b-65b3530c6a66': {
    visible: [
      Permission.HOME,
      Permission.PERSONAL,
      Permission.ASSIGNER,
      Permission.SERVICE_MANAGER,
      Permission.PROVIDERS,
      Permission.CLIENTS,
      Permission.COMMERCIAL,
      Permission.SWEEPERCAR,
      Permission.POOL_MANAGER,
      Permission.EXPENSES,
    ],
    hidden: [],
  },
  // Cafler -> Acceso completo
  '8A70B3EC-99A0-4AA9-8B6E-CDAFA3563A5F': {
    visible: [
      Permission.HOME,
      Permission.PERSONAL,
      Permission.ASSIGNER,
      Permission.PROVIDERS,
      Permission.COMMERCIAL,
      Permission.CLIENTS,
      Permission.SERVICE_MANAGER,
      Permission.SWEEPERCAR,
      Permission.POOL_MANAGER,
      Permission.EXPENSES,
    ],
    hidden: [],
  },
  // Copec -> No tiene acceso a Provedores, COMMERCIAL, Pool Manager ni Gastos
  '79ec8f0d-1881-4537-96ec-570c998ca881': {
    visible: [
      Permission.HOME,
      Permission.PERSONAL,
      Permission.ASSIGNER,
      Permission.SERVICE_MANAGER,
      Permission.CLIENTS,
      Permission.SWEEPERCAR,
    ],
    hidden: [
      Permission.COMMERCIAL,
      Permission.PROVIDERS,
      Permission.POOL_MANAGER,
      Permission.EXPENSES,
    ],
  },
  // OK Mobility -> No tiene acceso a Provedores, COMMERCIAL, Pool Manager ni Gastos
  '558b680a-c8dc-4ffe-bd51-5e766efa8f03': {
    visible: [
      Permission.HOME,
      Permission.PERSONAL,
      Permission.ASSIGNER,
      Permission.SERVICE_MANAGER,
      Permission.CLIENTS,
      Permission.SWEEPERCAR,
    ],
    hidden: [
      Permission.COMMERCIAL,
      Permission.PROVIDERS,
      Permission.POOL_MANAGER,
      Permission.EXPENSES,
    ],
  },
}).reduce((acc, [key, value]) => {
  acc[key.toLowerCase()] = value;
  return acc;
}, {} as Record<string, { visible: Permission[]; hidden: Permission[] }>);
